module.exports = __webpack_public_path__ + "static/media/pic02.491333c8.png";